exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#loading{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1\n}\n#loading i{Position:absolute;Top:50%;Transform:translateY(-50%);left:50%\n}\n.listing-parent{position:relative;z-index:0\n}\n.no-border{border:0\n}\n.wrapper{position:relative\n}\n.wrapper span.fas{position:absolute;top:20px;left:20px;color:#fff;box-shadow:0 0 5px 5px #000\n}\n.card{height:100%;width:100%\n}\n.quote{position:relative\n}\n.quote:before{content:\"\\201C\";position:absolute;font-family:serif;font-weight:700;top:-40px;left:-10px;font-size:130px;color:blue;opacity:.1\n}\n.vertical_center{display:flex;align-items:center\n}", ""]);

// exports
